<div class="mt-xs">
  <div *ngIf="patientInfo?.showOptions && patient" @fadeInAnimation>
    <p class="text-info mb-xlg">Puedes mantener la información actual del paciente o podrías hacer modificaciones.</p>
    <div nz-row [nzGutter]="[30, 30]">
      <div nz-col nzXs="24" nzSm="24" nzMd="12" nzLg="8" nzXl="6">
        <div class="item mb-xlg">
          <img loading="lazy" class="mr-xs" src="./../../../../assets/images/icons/icons8-id-verified-100.png" alt="">
          <div class="item-labels mr-sm">
            <p class="text-subtitle-bold-upper">Folio</p>
            <p *ngIf="patient.folioPrefix" @fadeInAnimation class="text-regular-12">{{
              patient.folioPrefix }}{{ patient.folioNumber }}</p>
            <p *ngIf="!patient.folioPrefix" @fadeInAnimation class="text-regular-12">
              &#45;&#45;</p>
          </div>
        </div>
        <div class="item mb-xlg">
          <img loading="lazy" class="mr-xs" src="./../../../../assets/images/icons/icons8-birthday-100.png" alt="">
          <div class="item-labels mr-sm">
            <p class="text-subtitle-bold-upper">Fecha de nacimiento</p>
            <p @fadeInAnimation class="text-regular-12">{{ (patient.user?.birthday |
              date:'dd/MM/yyyy') || '&#45;&#45;' }}</p>
          </div>
        </div>
        <div class="item">
          <img loading="lazy" class="mr-xs" src="./../../../../assets/images/icons/icons8-office-phone-100.png" alt="">
          <div class="item-labels mr-sm" @fadeInAnimation>
            <p class="text-subtitle-bold-upper">Teléfono</p>
            <p @fadeInAnimation class="text-regular-12"
              *ngIf="!patient.user?.phones || patient.user?.phones?.length === 0">&#45;&#45;</p>
            <p @fadeInAnimation class="text-regular-12"
              *ngIf="patient.user?.phones?.length> 0">{{ (patient.user.phones[0]) | getPhoneStructure }} </p>
          </div>
        </div>
      </div>

      <div nz-col nzXs="24" nzSm="24" nzMd="12" nzLg="8" nzXl="6">
        <div class="item mb-xlg">
          <img loading="lazy" class="mr-xs" src="./../../../../assets/images/icons/icons8-email-sign-100.png" alt="">
          <div class="item-labels mr-sm truncate">
            <p class="text-subtitle-bold-upper">Correo electrónico</p>
            <p @fadeInAnimation class="text-regular-12">{{ patient.user?.email }}</p>
          </div>
        </div>
        <div class="item mb-xlg">
          <img loading="lazy" class="mr-xs" src="./../../../../assets/images/icons/icons8-one-ring-100.png" alt="">
          <div class="item-labels mr-sm">
            <p class="text-subtitle-bold-upper">Estado civil</p>
            <p @fadeInAnimation class="text-regular-12">{{
              ((patient.civilState) | getTranslateEnum:'civilState') || '--' }}
            </p>
          </div>
        </div>
        <div class="item">
          <img loading="lazy" class="mr-xs" src="./../../../../assets/images/icons/icons8-genero-50.png" alt="">
          <div class="item-labels mr-sm">
            <p class="text-subtitle-bold-upper">Género</p>
            <p @fadeInAnimation class="text-regular-12">
              {{ patient.user?.gender | getTranslateEnum:'gender'}}
            </p>
          </div>
        </div>
      </div>

      <div nz-col nzXs="24" nzSm="24" nzMd="12" nzLg="8" nzXl="6">
        <div class="item mb-xlg">
          <img loading="lazy" class="mr-xs" src="./../../../../assets/images/icons/icons8-globe-100.png" alt="">
          <div class="item-labels mr-sm">
            <p class="text-subtitle-bold-upper">País</p>
            <p @fadeInAnimation class="text-regular-12">{{ patient.user?.address?.country ||
              '&#45;&#45;' }}</p>
          </div>
        </div>
        <div class="item mb-xlg">
          <img loading="lazy" class="mr-xs" src="./../../../../assets/images/icons/icons8-country-100.png" alt="">
          <div class="item-labels mr-sm">
            <p class="text-subtitle-bold-upper">Estado</p>
            <p @fadeInAnimation class="text-regular-12">{{ patient.user?.address?.state ||
              '&#45;&#45;'}}</p>
          </div>
        </div>
        <div class="item">
          <img loading="lazy" class="mr-xs" src="./../../../../assets/images/icons/icons8-city-100.png" alt="">
          <div class="item-labels mr-sm">
            <p class="text-subtitle-bold-upper">Ciudad</p>
            <p @fadeInAnimation class="text-regular-12">{{ patient.user?.address?.city ||
              '&#45;&#45;'}}</p>
          </div>
        </div>
      </div>

      <div nz-col nzXs="24" nzSm="24" nzMd="12" nzLg="8" nzXl="6">
        <div class="item mb-xlg">
          <img loading="lazy" class="mr-xs" src="./../../../../assets/images/icons/icons8-suburb-100.png" alt="">
          <div class="item-labels mr-sm">
            <p class="text-subtitle-bold-upper">Colonia</p>
            <p @fadeInAnimation class="text-regular-12">{{ patient.user?.address?.suburb ||
              '&#45;&#45;' }}</p>
          </div>
        </div>
        <div class="item mb-xlg">
          <img loading="lazy" class="mr-xs" src="./../../../../assets/images/icons/icons8-street-100.png" alt="">
          <div class="item-labels mr-sm">
            <p class="text-subtitle-bold-upper">Calle y número</p>
            <p @fadeInAnimation class="text-regular-12">{{ patient.user?.address?.street ||
              '&#45;&#45;' }}</p>
          </div>
        </div>
        <div class="item">
          <img loading="lazy" class="mr-xs" src="./../../../../assets/images/icons/icons8-postal-100.png" alt="">
          <div class="item-labels mr-sm">
            <p class="text-subtitle-bold-upper">Código postal</p>
            <p @fadeInAnimation class="text-regular-12">{{ patient.user?.address?.cp ||
              '&#45;&#45;'}}</p>
          </div>
        </div>
      </div>
    </div>

    <div class="d-flex justify-content-end mt-xlg">
      <button (click)="onSetEditionMode(true)" nz-button nzType="default" class="btn-default mr-xs shepherd-btn-edit-information">
        <i nz-icon nzType="edit" nzTheme="outline"></i>
        EDITAR INFORMACIÓN</button>
    </div>
  </div>
  <div *ngIf="!patientInfo?.showOptions && patientInfo?.isEdit" @fadeInAnimation>
    <div class="d-flex align-items-center">
      <i class="back-option mr-md" (click)="onBackPatientInfo()" nz-icon nzType="arrow-left" nzTheme="outline"></i>
      <div class="option-mini p-xs">
        <div class="option-mini-logo">
          <img loading="lazy" src="./../../../assets/images/icons/icons8-id-verified-100.png" alt="">
        </div>
        <div class="option-mini-text d-flex flex-column ml-xs">
          <p class="text-info mb-xxs">Editar información</p>
          <p class="text-info-bold-xs">Modificado {{ patient.updatedAt | date }}</p>
        </div>
      </div>
    </div>





    <form class="mt-xlg shepherd-patient-information-form" [formGroup]="this.form" nz-row [nzGutter]="[30, 30]">
      <!--columna 1-->
      <div nz-col nzXs="24" nzSm="24" nzMd="12" nzLg="8" nzXl="8" nzXXl="6">
        <div class="item align-start mb-lg">
          <img loading="lazy" class="mr-xs" src="./../../../assets/images/icons/icons8-id-verified-100.png" alt="">
          <div class="tw-w-full">
            <p class="text-subtitle-bold-upper">Folio</p>
            <input @fadeInAnimation nz-input disabled [placeholder]="patient.folioPrefix + '' + patient.folioNumber" type="text">
          </div>
        </div>
        <div class="item align-start mb-lg">
          <img loading="lazy" class="mr-xs" src="./../../../assets/images/icons/icons8-birthday-100.png" alt="">
          <div class="tw-w-full">
            <p class="text-subtitle-bold-upper">Fecha de nacimiento</p>
            <nz-date-picker @fadeInAnimation [nzFormat]="this.platformConfig.FORMAT.DATE.DDMMYYYY"
              name="ngDateOfBirth" [nzPlaceHolder]="'Fecha de nacimiento'" formControlName="birthday"
              [nzDisabledDate]="utilitiesService.disabledDate"></nz-date-picker>
            <app-message-field [field]="this.form | getFormGroup:'birthday'"></app-message-field>
          </div>
        </div>
        <div class="item align-start">
          <img loading="lazy" class="mr-xs" src="./../../../assets/images/icons/icons8-office-phone-100.png" alt="">
          <div class="tw-w-full">
            <p class="text-subtitle-bold-upper">Teléfono</p>
            <div @fadeInAnimation class="d-flex">
              <app-phones
                [limit]="1"
                [description]="''"
                [phones]="this.patient.user.phones"
                [withoutHeader]="true"
                [removeClassCardContainerShadow]="true"
                class="tw-w-full"
              ></app-phones>
            </div>
          </div>
        </div>
      </div>
      <!--columna 2-->
      <div nz-col nzXs="24" nzSm="24" nzMd="12" nzLg="8" nzXl="8" nzXXl="6">
        <div class="item align-start mb-lg">
          <img loading="lazy" class="mr-xs" src="./../../../assets/images/icons/icons8-email-sign-100.png" alt="">
          <div class="tw-w-full">
            <p class="text-subtitle-bold-upper">Correo electrónico</p>
            <input @fadeInAnimation nz-input formControlName="email"
              name="email" type="text"
              (ngModelChange)="helperValidationField.onValidateEmail(patient.user.email, this.form.get('email'))">
            <app-message-field [field]="this.form | getFormGroup:'email'"></app-message-field>
          </div>
        </div>
        <div class="item align-start mb-lg">
          <img loading="lazy" class="mr-xs" src="./../../../assets/images/icons/icons8-one-ring-100.png" alt="">
          <div class="tw-w-full">
            <p class="text-subtitle-bold-upper">Estado civil</p>
            <nz-select @fadeInAnimation formControlName="civilState" name="civilState">
              <nz-option [nzValue]="this.civilStateEnum.MARRIED" nzLabel="Casado(a)"></nz-option>
              <nz-option [nzValue]="this.civilStateEnum.DIVORCEE" nzLabel="Divorciado(a)"></nz-option>
              <nz-option [nzValue]="this.civilStateEnum.WINDOWED" nzLabel="Viudo(a)"></nz-option>
              <nz-option [nzValue]="this.civilStateEnum.SINGLE" nzLabel="Soltero(a)"></nz-option>
              <nz-option [nzValue]="this.civilStateEnum.IN_RELATIONSHIP" nzLabel="En relación"></nz-option>
            </nz-select>
            <app-message-field [field]="this.form | getFormGroup:'civilState'"></app-message-field>
          </div>
        </div>
        <div class="item align-start">
          <img loading="lazy" class="mr-xs" src="./../../../assets/images/icons/icons8-genero-50.png" alt="">
          <div class="tw-w-full">
            <p class="text-subtitle-bold-upper">Género</p>
            <nz-select @fadeInAnimation formControlName="gender" name="gender">
              <nz-option [nzValue]="this.genderEnum.FEMALE" nzLabel="Femenino"></nz-option>
              <nz-option [nzValue]="this.genderEnum.MALE" nzLabel="Masculino"></nz-option>
            </nz-select>
            <app-message-field [field]="this.form | getFormGroup:'gender'"></app-message-field>
          </div>
        </div>
      </div>
      <!--columna 3-->
      <div nz-col nzXs="24" nzSm="24" nzMd="12" nzLg="8" nzXl="8" nzXXl="6">
        <div class="item align-start mb-lg">
          <img loading="lazy" class="mr-xs" src="./../../../assets/images/icons/icons8-globe-100.png" alt="">
          <div class="tw-w-full">
            <p class="text-subtitle-bold-upper">País</p>
            <nz-select @fadeInAnimation nzShowSearch nzAllowClear nzPlaceHolder="País" formControlName="country" name="country">
              <nz-option *ngFor="let country of countries;" [nzLabel]="country.name" [nzValue]="country.name">
              </nz-option>
            </nz-select>
            <app-message-field [field]="this.form | getFormGroup:'country'"></app-message-field>
          </div>
        </div>
        <div class="item align-start mb-lg">
          <img loading="lazy" class="mr-xs" src="./../../../assets/images/icons/icons8-country-100.png" alt="">
          <div class="tw-w-full">
            <p class="text-subtitle-bold-upper">Estado</p>
            <ng-container *ngIf="this.form.get('country').value !== 'México'; else isMX">
              <input @fadeInAnimation nz-input formControlName="state" name="state" placeHolder="Estado">
              <app-message-field [field]="this.form | getFormGroup:'state'"></app-message-field>
            </ng-container>
            <ng-template #isMX>
              <nz-select @fadeInAnimation nzShowSearch nzAllowClear nzPlaceHolder="Estado" formControlName="state" name="state">
                <nz-option *ngFor="let state of mexicoStates;" [nzLabel]="state.name" [nzValue]="state.name">
                </nz-option>
              </nz-select>
              <app-message-field [field]="this.form | getFormGroup:'state'"></app-message-field>
            </ng-template>
          </div>
        </div>
        <div class="item align-start">
          <img loading="lazy" class="mr-xs" src="./../../../assets/images/icons/icons8-city-100.png" alt="">
          <div class="tw-w-full">
            <p class="text-subtitle-bold-upper">Ciudad</p>
            <input @fadeInAnimation nz-input formControlName="city" name="city" placeHolder="Ciudad">
            <app-message-field [field]="this.form | getFormGroup:'city'"></app-message-field>
          </div>
        </div>
      </div>
      <!--columna 4-->
      <div nz-col nzXs="24" nzSm="24" nzMd="12" nzLg="8" nzXl="8" nzXXl="6">
        <div class="item align-start mb-lg">
          <img loading="lazy" class="mr-xs" src="./../../../assets/images/icons/icons8-suburb-100.png" alt="">
          <div class="tw-w-full">
            <p class="text-subtitle-bold-upper">Colonia</p>
            <input @fadeInAnimation nz-input formControlName="suburb" name="suburb" placeholder="Colonia">
            <app-message-field [field]="this.form | getFormGroup:'suburb'"></app-message-field>
          </div>
        </div>
        <div class="item align-start mb-lg">
          <img loading="lazy" class="mr-xs" src="./../../../assets/images/icons/icons8-street-100.png" alt="">
          <div class="tw-w-full">
            <p class="text-subtitle-bold-upper">Calle y número</p>
            <input @fadeInAnimation nz-input formControlName="street" name="street" placeHolder="Calle con número">
            <app-message-field [field]="this.form | getFormGroup:'street'"></app-message-field>
          </div>
        </div>
        <div class="item align-start">
          <img loading="lazy" class="mr-xs" src="./../../../assets/images/icons/icons8-postal-100.png" alt="">
          <div class="tw-w-full">
            <p class="text-subtitle-bold-upper">Código postal</p>
            <input nz-input @fadeInAnimation maxlength="6" formControlName="cp" name="cp" nzPlaceHolder="Código postal"
              (ngModelChange)="this.helperValidationField.onValidateCP(patient.user.address, this.form.get('cp'))">
            <app-message-field [field]="this.form | getFormGroup:'cpp'"></app-message-field>
          </div>
        </div>
      </div>
    </form>
    <div class="d-flex justify-content-end mt-xlg">
      <button (click)="this.onSavePatient()" class="mt-xlg ml-xs shepherd-patient-information-btn-save" nz-button nzType="primary">
        <i nz-icon nzType="save" nzTheme="outline"></i>
        GUARDAR
      </button>
    </div>
  </div>
</div>
